import { z } from 'zod';
import {
    IMPLEMENTATION_STATUSES,
    isValidTargetStatus,
} from './measure-evaluation.constants.js';

export const ImplementationStatusSchema = z.enum(IMPLEMENTATION_STATUSES);

export const MeasureEvaluationCurrentSituationSchema = z.object({
    implementationStatus: ImplementationStatusSchema.nullable().optional(),
    currentExplanation: z.string().trim().optional().default(''),
    targetStatus: ImplementationStatusSchema.nullable().optional(),
    targetRequiredWork: z.string().trim().optional().default(''),
});

export const UpdateMeasureEvaluationCurrentSituationSchema = z.object({
    implementationStatus: ImplementationStatusSchema,
    currentExplanation: z.string().trim().optional().default(''),
    targetStatus: ImplementationStatusSchema.nullable().optional(),
    targetRequiredWork: z.string().trim().optional().default(''),
}).superRefine((data, ctx) => {
    if (!isValidTargetStatus(data.implementationStatus, data.targetStatus ?? null)) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'Hedeflenen durum, uygulanma durumundan daha yüksek olmalıdır',
            path: ['targetStatus'],
        });
    }
});
